export default {
  attributesTitle: {
    id: 'product_comparison_attributes_title',
    defaultMessage: 'How they compare',
  },
} as const
